export function formatWebsite(url: string) {
  if (url == null) {
    return "";
  } else if (url.substr(0, 4) === "http") {
    return url;
  }
  return "//" + url;
}
